export enum FILE_EXTENSIONS {
    PNG = "png",
    PDF = "pdf",
    DOC = "DOC",
    DOCX = "DOCX",
    JPEG = "JPEG"
}